<script setup lang="ts">
  import { Button } from '@/components/ui/button'
  import { useThemeColor } from '@/composables/useThemeColorV3'
  import { useTranslation } from '@/composables/useTranslation'
  import { computed } from 'vue'

  interface Props {
    class?: string
  }

  const props = defineProps<Props>()
  const themeColor = computed(() => useThemeColor().value)
  const { t } = useTranslation({
    en: {
      complete: 'Complete'
    },
    de: {
      complete: 'Bearbeiten'
    }
  })
</script>
<template>
  <Button
    :class="[
      'h-8 font-normal',
      props.class || 'w-[99px]',
      `bg-${themeColor}-600 hover:bg-${themeColor}-700 border-transparent text-white`
    ]"
  >
    {{ t('complete') }}
  </Button>
</template>
